<template>
  <div
    class="item-seminaire"
    v-if="content"
    v-editable="content"
    :style="`background-image:url('${content.img}')`"
  >
    <div class="wrapper">
      <div class="container">
        <p class="titre">{{content.Title}}</p>
        <div class="break"></div>
      </div>
    </div>
    <div class="content">
      <div class="content-text">
        <vue-markdown class="txt">{{content.text}}</vue-markdown>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  props: {
    content: null
  }
};
</script>

<style lang="scss">
.item-seminaire {
  width: 100%;
  height: 300px;
  color: white;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;

  .wrapper {
    height: 300px;
    position: absolute;
  }

  .break {
    background-color: white;
    height: 5px;
    width: 40px;
    position: absolute;
    right: 0;
    top: 10%;
    right: 15px;
  }

  &:nth-child(odd) {
    .content {
      clip-path: polygon(45% 0, 100% 0%, 100% 100%, 59% 100%);
      transition: transform 0.2s ease-in-out;
      transform: translateX(500px);
    }
    .wrapper {
      z-index: 1;
      right: 15px;
      top: 50%;
      transition: transform 0.2s ease-in-out;
      transform: translateY(0px);
      .container {
        display: flex;
        flex-direction: column;
        height: 50%;
        .break {
          width: 40px;
          right: 0;
        }
        .titre {
          transition: font-size 0.2s ease-in-out;
          font-size: 26px;
        }
      }
    }
    &:hover {
      .content {
        transition: transform 0.2s ease-in-out;
        transform: translateX(0px);
      }
      .wrapper {
        transition: transform 0.2s ease-in-out;
        transform: translateY(-90px);
        right: 15px;
        .container {
          .titre {
            transition: font-size 0.2s ease-in-out;
            font-size: 16px;
          }
        }
      }
      .content-text {
        display: flex;
        flex-direction: column;
        position: absolute;
        right: -20px;
        width: 50%;
        top: 40%;

        .titre {
          font-size: 30px;
          padding: 20px 15px;
          padding-right: 0;
          width: 85%;
          text-align: center;
        }

        .txt {
          padding: 0 3em;
        }
      }
    }
  }
  &:nth-child(even) {
    .content {
      clip-path: polygon(0 0, 55% 0, 41% 100%, 0 100%);
      transition: transform 0.2s ease-in-out;
      transform: translateX(-500px);
      .content-text {
        display: flex;
        flex-direction: column;
        position: absolute;
        left: -100px;
        width: 50%;
        top: 40%;
        .titre {
          font-size: 30px;
          padding: 20px 15px;
          padding-left: 1em;
          width: 85%;
          text-align: center;
        }

        .txt {
          padding: 0 3em;
          padding-left: 1.5em;
        }
      }
    }
    .wrapper {
      z-index: 1;
      left: 15px;
      top: 50%;
      transition: transform 0.2s ease-in-out;
      transform: translateY(0px);
      .container {
        display: flex;
        flex-direction: column;
        height: 50%;
        .break {
          width: 40px;
          left: 0;
        }
        .titre {
          transition: font-size 0.2s ease-in-out;
          font-size: 26px;
        }
      }
    }
    &:hover {
      .content {
        transition: transform 0.2s ease-in-out;
        transform: translateX(0px);
      }
      .wrapper {
        left: 15px;
        transition: transform 0.2s ease-in-out;
        transform: translateY(-90px);
        .container {
          .titre {
            transition: font-size 0.2s ease-in-out;
            font-size: 16px;
          }
        }
      }
      .content-text {
        display: flex;
        flex-direction: column;
        position: absolute;
        left: -10px;
        width: 50%;
        top: 40%;

        .titre {
          font-size: 30px;
          padding: 20px 15px;
          padding-left: 1em;
          width: 85%;
          text-align: center;
        }

        .txt {
          padding: 0 3em;
          padding-left: 1.5em;
        }
      }
    }
  }

  .content {
    display: flex;
    justify-content: center;
    width: 101%;
    height: 100%;
    background-color: rgba(70, 190, 213, 0.8);

    position: relative;
    .content-text {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: -20px;
      width: 50%;
      top: 50%;

      .titre {
        font-size: 30px;
        padding: 20px 15px;
        padding-right: 0;
        width: 85%;
        text-align: center;
      }

      .txt {
        padding: 0 3em;
      }
    }
  }
}
</style>
